import React from 'react';

export const MssqlPropertyLayout = ({ fields, values }) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get('mssql_host')}</div>
      <div className="col-3">{fields.get('mssql_port')}</div>
      <div className="col-6">{fields.get('mssql_database')}</div>
      <div className="col-6">{fields.get('mssql_instance')}</div>
      <div className="col-6">{fields.get('mssql_username')}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('mssql_password')}
          {fields.get('mssql_passwordChange')}
        </div>
      </div>
      <div className="col-6">{fields.get('mssql_sslEnabled')}</div>
      <div className="col-6">{fields.get('mssql_sslProtocol')}</div>
      <div className="col-6">{fields.get('mssql_windowsauthenabled')}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get('mssql_change_sslrootcert')
        ? fields.get('mssql_current_sslrootcert')
        : fields.get('mssql_sslrootcert')}
      {fields.get('mssql_change_sslrootcert')}
    </div>
    <div className="form-group--toggle">
      {!values.get('mssql_change_sslcert')
        ? fields.get('mssql_current_sslcert')
        : fields.get('mssql_sslcert')}
      {fields.get('mssql_change_sslcert')}
    </div>
    <div className="row">
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('mssql_trustStorePassword')}
          {fields.get('mssql_trustStorePasswordChange')}
        </div>
      </div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('mssql_keyStoreSecret')}
          {fields.get('mssql_keyStoreSecretChange')}
        </div>
      </div>
    </div>
  </>
);

export const OraclePropertyLayout = ({ fields, values }) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get('oracle_host')}</div>
      <div className="col-3">{fields.get('oracle_port')}</div>
      <div className="col-12">{fields.get('oracle_service')}</div>
      <div className="col-6">{fields.get('oracle_username')}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('oracle_password')}
          {fields.get('oracle_passwordChange')}
        </div>
      </div>
      <div className="col-4">{fields.get('oracle_sslEnabled')}</div>
      <div className="col-4">{fields.get('oracle_sslVersion')}</div>
      <div className="col-4">{fields.get('oracle_sslServerDnMatch')}</div>
      <div className="col-12">{fields.get('oracle_ciphersuites')}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get('oracle_change_serverCert')
        ? fields.get('oracle_current_serverCert')
        : fields.get('oracle_serverCert')}
      {fields.get('oracle_change_serverCert')}
    </div>
    <div className="form-group--toggle">
      {!values.get('oracle_change_clientCert')
        ? fields.get('oracle_current_clientCert')
        : fields.get('oracle_clientCert')}
      {fields.get('oracle_change_clientCert')}
    </div>
    <div className="row">
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('oracle_trustStorePassword')}
          {fields.get('oracle_trustStorePasswordChange')}
        </div>
      </div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('oracle_keyStorePassword')}
          {fields.get('oracle_keyStorePasswordChange')}
        </div>
      </div>
    </div>
  </>
);

export const PostgresPropertyLayout = ({ fields, values }) => (
  <>
    <div className="heading heading-sm">
      <h3 className="h4">Adapter Properties</h3>
    </div>
    <div className="row">
      <div className="col-9">{fields.get('postgres_host')}</div>
      <div className="col-3">{fields.get('postgres_port')}</div>
      <div className="col-12">{fields.get('postgres_database')}</div>
      <div className="col-6">{fields.get('postgres_username')}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('postgres_password')}
          {fields.get('postgres_passwordChange')}
        </div>
      </div>
      <div className="col-6">{fields.get('postgres_sslEnabled')}</div>
      <div className="col-6">{fields.get('postgres_sslmode')}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get('postgres_change_sslrootcert')
        ? fields.get('postgres_current_sslrootcert')
        : fields.get('postgres_sslrootcert')}
      {fields.get('postgres_change_sslrootcert')}
    </div>
    <div className="form-group--toggle">
      {!values.get('postgres_change_sslcert')
        ? fields.get('postgres_current_sslcert')
        : fields.get('postgres_sslcert')}
      {fields.get('postgres_change_sslcert')}
    </div>
    <div className="form-group--toggle">
      {!values.get('postgres_change_sslkey')
        ? fields.get('postgres_current_sslkey')
        : fields.get('postgres_sslkey')}
      {fields.get('postgres_change_sslkey')}
    </div>
  </>
);

export const DATABASE_ADAPTER_FIELDS = spaceSlug => ({
  mssql_current_sslrootcert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_mssql_sslrootcert.crt`,
    },
  },
  mssql_current_sslcert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_mssql_sslcert.crt`,
    },
  },
  oracle_current_serverCert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_oracle_serverCert.crt`,
    },
  },
  oracle_current_clientCert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_oracle_clientCert.crt`,
    },
  },
  postgres_current_sslrootcert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_postgres_sslrootcert.crt`,
    },
  },
  postgres_current_sslcert: {
    renderAttributes: {
      filename: `${spaceSlug || 'system'}_task_postgres_sslcert.crt`,
    },
  },
});
